import { useClientReference } from '@shared/hooks/useClientReference';
import { useCallback } from 'react';

export const useThingToDo = () => {
  const { clientReference } = useClientReference();
  const constructCampaignUrl = useCallback(
    (url: string) => {
      const campaignUrl = new URL(url);
      campaignUrl.searchParams.set('campaign', clientReference);
      return campaignUrl.href;
    },
    [clientReference],
  );

  return { constructCampaignUrl };
};
